// Frontend feature flags.
// Automatic application follow-ups are hidden on every plan for now. The code
// is kept (not deleted); flip this to true to bring the UI back.
export const FOLLOW_UPS_ENABLED = false;
